/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import e from"./LayerView.js";import{RefreshableLayerView as r}from"./RefreshableLayerView.js";class s extends(r(e)){constructor(){super(...arguments),this.layer=null}}export{s as default};
